import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

function AddRouteLocation() {
    const navigate = useNavigate();
    const routeLocation = useLocation();
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const userData = sessionStorage.getItem("user");
    const userObj = userData ? JSON.parse(userData) : {};

    const [editId, setEditId] = useState(null);

    const [form, setForm] = useState({
        route_location_id: "",
        location_name: "",
        status: "",
        school_id: userObj?.school_id || ""
    });


    // useEffect(() => {
    //     if (routeLocation.state?.routeData) {
    //         const routeData = routeLocation.state.routeData;
    //         setForm({
    //             route_location_id: routeData.route_location_id || "",
    //             location_name: routeData.location_name || "",
    //             status: routeData.status || "A",
    //             school_id: userObj?.school_id || ""
    //         });
    //         setEditId(routeData.route_location_id);
    //         window.history.replaceState({}, document.title);
    //     }
    // }, [routeLocation, userObj]);
    useEffect(() => {
        if (routeLocation.state?.routeData) {
            const routeData = routeLocation.state.routeData;
            setForm(routeData);
            setEditId(routeData.route_location_id);
        }
    }, [routeLocation]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.location_name) {
            toast.error("Please enter location name");
            return;
        }

        const formData = {
            route_location_id: editId || null,
            location_name: form.location_name || "",
            status: "A",
            school_id: userObj.school_id,
            action: editId !== null ? "UPDATE" : "CREATE",
        };

        try {
            await axios.post(`${baseUrl}/routelocation/`, formData, {
                headers: { "Content-Type": "application/json" },
            });

            toast.success(
                editId ? "Record Updated Successfully" : "Record Added Successfully"
            );

            // ✅ Clear the form only if it's a new record
            setForm({
                route_location_id: "",
                location_name: "",
                status: "",
                school_id: userObj?.school_id || "",
            });
            setEditId(null);

        } catch (error) {
            console.error("Error submitting data:", error.response?.data || error.message);
            toast.error("Record already exists");
        }
    };



    return (
        <div className="pageBody">
            <ToastContainer />
            <Container fluid>
                <Card>
                    <Card.Body>
                        <form onSubmit={handleSubmit}>
                            <div>
                                <Row>
                                    <Col xs={12}>
                                        <h6 className="commonSectionTitle">
                                            Add Route Location
                                        </h6>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6} lg={4} xxl={3}>
                                        <div className="commonInput">
                                            <Form.Group>
                                                <Form.Label>Location Name<span className="requiredStar">*</span></Form.Label>
                                                <Form.Control
                                                    required
                                                    type="text"
                                                    id="location_name"
                                                    value={form.location_name}
                                                    placeholder="Enter Location Name"
                                                    maxLength={50}
                                                    onChange={handleInputChange}
                                                />
                                                <Form.Control.Feedback>Required</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    </Col>

                                </Row>
                            </div>

                            <div className="d-flex justify-content-between mt-3">
                                <Button
                                    type="button"
                                    variant="primary"
                                    className="btn-info clearBtn"
                                    onClick={() =>
                                        setForm((prevForm) => ({
                                            ...prevForm,   // keep existing keys like route_location_id
                                            location_name: "",
                                            // status: "A",   // reset to default "A"
                                            school_id: userObj?.school_id || ""
                                        }))
                                    }
                                >
                                    Reset
                                </Button>
                                <div>
                                    <Button
                                        type="button"
                                        variant="primary"
                                        className="btn-danger secondaryBtn me-2"
                                        onClick={() => window.history.back()}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="btn-success primaryBtn"
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
}

export default AddRouteLocation;
